/* eslint-disable import/no-restricted-paths */
import { type AccountRoutes } from 'account/src/app/App'
import { type AdminRoutes } from 'admin/src/app/App'
import { type SettingsRoutes } from 'settings-app/src/types'
import { type ForumRoutes } from 'forum/src/app/App'
import { type UserFeedRoutes } from 'user-feed/src/app/App'
import { type GroupProfileRoutes } from 'group-profile/src/app/App'
import { type GroupSettingsRoutes } from 'group-settings/src/app/App'
import { type EventsRoutes } from 'events/src/app/App'
import { type DiscoverRoutes } from 'discover/src/app/App'
import { type UserProfileRoutes } from 'user-profile/src/app/App'
import { type HostRoutes } from 'host/src/app/Router/routes/hostRoutes'
/* eslint-enable import/no-restricted-paths */
import { fillRoute, type FillRouteProps } from '../fillRoute'
import { type RouteProps } from '../types'

export type AppsRoutes =
  | AccountRoutes
  | AdminRoutes
  | SettingsRoutes
  | ForumRoutes
  | GroupProfileRoutes
  | GroupSettingsRoutes
  | EventsRoutes
  | DiscoverRoutes
  | UserFeedRoutes
  | UserProfileRoutes
  | HostRoutes

export const getRoute = <T = RouteProps>(
  route: AppsRoutes,
  props?: T,
  { skipParams = false }: FillRouteProps = {},
) => (props ? (fillRoute(route, props, { skipParams }) as AppsRoutes) : route)

export const getFullUrl = <T = RouteProps>(
  route: AppsRoutes,
  props?: T,
  { skipParams = false }: FillRouteProps = {},
) => {
  const routePath = getRoute(route, props, { skipParams })
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  return `${origin}${routePath}`
}
